export default __webpack_public_path__ + "static/media/xellark.083a1439.png";